import { ObjectDefinitions } from "../types/ObjectDefinitionTypes";

const objects: ObjectDefinitions[] = [
  {
    name: "egg_lab_shelf",
    image: "egg_lab_shelf",
    type: "sceneObject",
  },
  {
    name: "egg_lab_scale",
    image: "egg_lab_scale",
    type: "interactableObject",
    buttons: [
      {
        title: "Zero scale",
        icon: "zero",
        type: "UpdateState",
        actionName: "ZERO_BUTTON_ACTION",
      },
      {
        title: "Record data",
        icon: "PencilSolidIcon",
        type: "Modal",
        modal: "ElectronicScaleModal",
      },
    ],
    states: [
      {
        name: "scale",
        image: "egg_lab_scale",
        label: {
          text: "Scale",
          offset: -70,
        },
      },
      {
        name: "scale__tray",
        image: "egg_lab_scale_with_tray",
        label: {
          text: "Scale",
          offset: -60,
        },
        buttons: [
          {
            title: "Remove tray from scale",
            icon: "remove_tray",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale",
              },
            ],
            actionName: "REMOVE_TRAY_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale_zeroed__tray",
        image: "egg_lab_scale_with_tray",
        label: {
          text: "Scale",
          offset: -60,
        },
        buttons: [
          {
            title: "Remove tray from scale",
            icon: "remove_tray",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale",
              },
            ],
            actionName: "REMOVE_TRAY_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale__beaker",
        image: "egg_lab_scale_with_beaker",
        buttons: [
          {
            title: "Remove beaker from scale",
            icon: "remove_beaker",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale",
              },
            ],
            actionName: "REMOVE_BEAKER_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale_zeroed__beaker",
        image: "egg_lab_scale_with_beaker",
        buttons: [
          {
            title: "Remove beaker from scale",
            icon: "remove_beaker",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale",
              },
            ],
            actionName: "REMOVE_BEAKER_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale__beaker__egg",
        image: "egg_lab_scale_with_egg_in_beaker",
        buttons: [
          {
            title: "Remove beaker from scale",
            icon: "remove_beaker",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale",
              },
            ],
            actionName: "REMOVE_BEAKER_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale__beaker__egg_shell_less",
        image: "egg_lab_scale_with_shell_less_egg_in_beaker",
        buttons: [
          {
            title: "Remove beaker from scale",
            icon: "remove_beaker",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale",
              },
            ],
            actionName: "REMOVE_BEAKER_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale__tray__egg_shell_less",
        image: "egg_lab_scale_with_shell_less_egg",
      },
      {
        name: "scale__tray__egg_di_water",
        image: "egg_lab_scale_with_egg_in_di_water",
        label: {
          text: "Scale",
          offset: -50,
        },
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale_zeroed__tray",
              },
            ],
            actionName: "REMOVE_EGG_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale__tray__egg_corn_syrup",
        image: "egg_lab_scale_with_egg_in_corn_syrup",
        label: {
          text: "Scale",
          offset: -50,
        },
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale_zeroed__tray",
              },
            ],
            actionName: "REMOVE_EGG_FROM_SCALE",
          },
        ],
      },
      {
        name: "scale__tray__egg_salt_water",
        image: "egg_lab_scale_with_egg_in_salt_water",
        label: {
          text: "Scale",
          offset: -50,
        },
        buttons: [
          {
            title: "Remove Beaker",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "scale_zeroed__tray",
              },
            ],
            actionName: "REMOVE_EGG_FROM_SCALE",
          },
        ],
      },
    ],
  },
  {
    name: "plastic_wrap_roll",
    image: "plastic_wrap_roll",
    type: "interactableObject",
  },
  {
    name: "plastic_wrap",
    image: "plastic_wrap",
    type: "controllableObject",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "hidden_on_drop",
        image: "",
      },
      {
        name: "default",
        image: "plastic_wrap",
      },
      {
        name: "trashed",
        image: "",
      },
    ],
  },
  {
    name: "egg_lab_tray",
    image: "egg_lab_tray",
    type: "controllableObject",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "hidden_on_drop",
        image: "",
      },
      {
        name: "default",
        image: "egg_lab_tray",
      },
    ],
  },
  {
    name: "egg_lab_trays",
    image: "egg_lab_trays",
    type: "interactableObject",
  },
  {
    name: "egg_lab_di_water",
    image: "egg_lab_di_water",
    type: "controllableObject",
  },

  {
    name: "egg_lab_salt_water",
    image: "egg_lab_salt_water",
    type: "controllableObject",
  },
  {
    name: "egg_lab_vinegar",
    image: "egg_lab_vinegar",
    type: "controllableObject",
  },
  {
    name: "egg_lab_corn_syrup",
    image: "egg_lab_corn_syrup",
    type: "controllableObject",
  },
  {
    name: "egg",
    image: "egg",
    type: "controllableObject",
    states: [
      {
        name: "hidden",
        image: "",
      },
      {
        name: "hidden_on_drop",
        image: "",
      },
      {
        name: "egg",
        image: "egg",
      },
      {
        name: "egg_corn_syrup",
        image: "egg_corn_syrup",
        label: {
          text: "Corn syrup egg",
        },
      },
      {
        name: "egg_corn_syrup__scale",
        image: "",
      },
      {
        name: "egg_salt_water",
        image: "egg_salt_water",
        label: {
          text: "Salt water egg",
        },
      },
      {
        name: "egg_salt_water__scale",
        image: "",
      },
      {
        name: "egg_di_water",
        image: "egg_di_water",
        label: {
          text: "DI water egg",
        },
      },
      {
        name: "egg_di_water__scale",
        image: "",
      },
      {
        name: "egg_shell_less",
        image: "egg_with_no_shell",
        label: {
          text: "Shell-less egg",
        },
      },
    ],
  },
  {
    name: "egg_lab_beaker",
    image: "",
    type: "controllableObject",
    states: [
      {
        name: "hidden_on_drop",
        image: "",
      },
      {
        name: "beaker_pre_zero",
        image: "egg_lab_beaker",
      },
      {
        name: "beaker_pre_weight",
        image: "egg_lab_beaker",
      },
      {
        name: "beaker",
        image: "egg_lab_beaker",
      },
      {
        name: "beaker__water",
        image: "egg_lab_beaker_with_water",
        buttons: [
          {
            title: "Remove liquid",
            icon: "remove_dye",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker",
              },
            ],
          },
        ],
      },
      {
        name: "beaker__egg_shell_less",
        image: "egg_lab_beaker_with_shell_less_egg",
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker",
              },
            ],
            actionName: "REMOVE_EGG_FROM_BEAKER",
          },
        ],
      },
      {
        name: "beaker__water__egg_shell_less",
        image: "egg_lab_beaker_with_egg_in_liquid",
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__water",
              },
            ],
            actionName: "REMOVE_EGG_FROM_BEAKER",
          },
        ],
      },
      {
        name: "beaker__egg_salt_water",
        image: "egg_lab_beaker_with_egg_in_salt_water",
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__water",
              },
            ],
            actionName: "REMOVE_EGG_FROM_BEAKER",
          },
        ],
      },
      {
        name: "beaker__egg_di_water",
        image: "egg_lab_beaker_with_egg_in_di_water",
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__water",
              },
            ],
            actionName: "REMOVE_EGG_FROM_BEAKER",
          },
        ],
      },
      {
        name: "beaker__egg_corn_syrup",
        image: "egg_lab_beaker_with_egg_in_corn_syrup",
        buttons: [
          {
            title: "Remove egg",
            icon: "remove_egg",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__water",
              },
            ],
            actionName: "REMOVE_EGG_FROM_BEAKER",
          },
        ],
      },
      {
        name: "beaker_wrapped__water__egg_shell_less",
        image: "egg_lab_beaker_wrapped_with_egg_in_liquid",
        buttons: [
          {
            title: "Remove plastic wrap covering",
            icon: "remove_plastic_wrap",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__water__egg_shell_less",
              },
            ],
          },
        ],
      },
      {
        name: "beaker_wrapped__egg_di_water",
        image: "egg_lab_beaker_wrapped_with_egg_in_di_water",
        buttons: [
          {
            title: "Remove plastic wrap covering",
            icon: "remove_plastic_wrap",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__egg_di_water",
              },
            ],
          },
        ],
      },
      {
        name: "beaker_wrapped__egg_corn_syrup",
        image: "egg_lab_beaker_wrapped_with_egg_in_corn_syrup",
        buttons: [
          {
            title: "Remove plastic wrap covering",
            icon: "remove_plastic_wrap",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__egg_corn_syrup",
              },
            ],
          },
        ],
      },
      {
        name: "beaker_wrapped__egg_salt_water",
        image: "egg_lab_beaker_wrapped_with_egg_in_salt_water",
        buttons: [
          {
            title: "Remove plastic wrap covering",
            icon: "remove_plastic_wrap",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "beaker__egg_salt_water",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "egg_box",
    image: "egg_box_full",
    type: "interactableObject",
    states: [
      {
        name: "egg_box_full",
        image: "egg_box_full",
        buttons: [
          {
            icon: "remove_egg",
            title: "remove",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "egg_box_7_eggs",
              },
            ],
            actionName: "REMOVE_EGG",
          },
        ],
      },
      {
        name: "egg_box_7_eggs",
        image: "egg_box_7_eggs",
        buttons: [
          {
            icon: "remove_egg",
            title: "remove",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "egg_box_6_eggs",
              },
            ],
            actionName: "REMOVE_EGG",
          },
        ],
      },
      {
        name: "egg_box_6_eggs",
        image: "egg_box_6_eggs",
        buttons: [
          {
            icon: "remove_egg",
            title: "remove",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "egg_box_5_eggs",
              },
            ],
            actionName: "REMOVE_EGG",
          },
        ],
      },
      {
        name: "egg_box_5_eggs",
        image: "egg_box_5_eggs",
      },
    ],
  },
  {
    name: "egg_lab_glass",
    image: "egg_lab_glass_empty",
    type: "interactableObject",
    states: [
      {
        name: "glass",
        image: "egg_lab_glass_empty",
        altText: "Vinegar glass with nothing in it",
      },
      {
        name: "glass__vinegar",
        image: "egg_lab_glass_with_vinegar",
        altText: "Vinegar glass with vinegar in it",
        buttons: [
          {
            icon: "remove_dye",
            title: "Remove liquid",
            type: "UpdateState",
            stateUpdates: [
              {
                nextState: "glass",
              },
            ],
          },
        ],
      },
      {
        name: "glass__egg",
        image: "egg_lab_glass_with_egg",
        altText: "Vinegar glass with egg in it",
        buttons: [
          {
            icon: "remove_egg",
            title: "Remove Egg",
            type: "UpdateState",
            actionName: "REMOVE_EGG_FROM_GLASS",
            stateUpdates: [
              {
                nextState: "glass",
              },
            ],
          },
        ],
      },
      {
        name: "glass__vinegar__egg",
        image: "egg_lab_glass_with_egg_in_vinegar",
        altText: "Vinegar glass with vinegar and egg in it",
        buttons: [
          {
            icon: "remove_egg",
            title: "Remove egg",
            type: "UpdateState",
            actionName: "REMOVE_EGG_FROM_GLASS",
            stateUpdates: [
              {
                nextState: "glass__vinegar",
              },
            ],
          },
        ],
      },
      {
        name: "glass__vinegar__egg_shell_less",
        image: "egg_lab_glass_with_shell_less_egg_in_vinegar",

        altText: "Vinegar glass with vinegar and shell-less egg in it",
        buttons: [
          {
            icon: "remove_egg",
            title: "Remove egg",
            type: "UpdateState",
            actionName: "REMOVE_EGG_FROM_GLASS",
            stateUpdates: [
              {
                nextState: "glass__vinegar",
              },
            ],
          },
        ],
      },
    ],
  },
  {
    name: "egg_lab_bin",
    image: "egg_lab_bin",
    type: "interactableObject",
    states: [
      {
        name: "open",
        image: "egg_lab_bin_open",
      },
      {
        name: "closed",
        image: "egg_lab_bin",
      },
    ],
  },
];

export default objects;
